import { forwardRef, ReactNode } from "react";
import { Flex, FlexProps } from "@chakra-ui/react";
import { sharedProps } from "~/constants";

interface Props extends FlexProps {
  bg?: string;
  children: ReactNode;
}

export const FullBleedSection = forwardRef<HTMLDivElement, Props>(
  function FullBleedSection({ children, ...props }, ref) {
    return (
      <Flex
        align="center"
        justify="center"
        direction="column"
        position="relative"
        {...sharedProps.fullBleed}
        {...props}
        ref={ref}
      >
        {children}
      </Flex>
    );
  },
);
